import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { Button, ModalDefault, Notice, Text } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import { escapeHtml } from "@components/ow";

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

/**
 * Excluir grupo. Só grupo vazio pode ser excluído: com pessoas, o modal leva a elas.
 * Excluir revoga na hora o "Ver dados confidenciais" de quem via o grupo.
 */
export default function DeleteGroupModal({ group, onClose, onDeleted, onViewMembers }) {
  const groupsService = useService("confidentialGroups");
  const [loading, setLoading] = useState(false);
  const members = group.members_count;
  const viewers = group.viewers_count ?? 0;

  function close() {
    if (!loading) onClose();
  }

  async function confirm() {
    setLoading(true);
    try {
      await groupsService.deleteGroup(group.id);
      toast.success("Grupo excluído.");
      setLoading(false);
      onDeleted();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.msg || "Erro ao excluir o grupo.");
      setLoading(false);
    }
  }

  return (
    <ModalDefault
      $showModal
      $setShowModal={close}
      $noClose={loading}
      $size="medium"
      $title="Excluir grupo?"
      $contentBackground="N0"
      $footer={
        members > 0 ? (
          <>
            <Button $text="Cancelar" $variant="outline" $action={close} $noWidth />
            <Button $text="Ver pessoas do grupo" $variant="primary" $action={onViewMembers} $noWidth />
          </>
        ) : (
          <>
            <Button $text="Cancelar" $variant="outline" $action={close} $isDisabled={loading} $noWidth />
            <Button $text="Excluir grupo" $variant="danger" $action={confirm} $isLoading={loading} $noWidth />
          </>
        )
      }
    >
      {members > 0 ? (
        <Notice
          $variant="orange"
          $text={`O grupo <strong>${escapeHtml(group.name)}</strong> ainda tem ${members} ${
            members === 1 ? "pessoa" : "pessoas"
          }. Tire as pessoas do grupo antes de excluí-lo.`}
        />
      ) : (
        <Body>
          <Text
            $text="<strong>%s</strong>"
            $replaces={[escapeHtml(group.name)]}
            $variant="paragraph_small_medium"
            $color="N900"
            $colorEmphasis="N900"
          />
          <Text
            $text={
              viewers > 0
                ? `A exclusão não tem volta. ${
                    viewers === 1
                      ? '1 colaborador perde a permissão "Ver dados confidenciais" neste grupo.'
                      : `${viewers} colaboradores perdem a permissão "Ver dados confidenciais" neste grupo.`
                  }`
                : "A exclusão não tem volta."
            }
            $variant="paragraph_small_medium"
            $color="N700"
          />
        </Body>
      )}
    </ModalDefault>
  );
}
